import { render } from "./ElementForm.vue?vue&type=template&id=b06b3132&scoped=true"
import script from "./ElementForm.vue?vue&type=script&lang=js"
export * from "./ElementForm.vue?vue&type=script&lang=js"

import "./ElementForm.vue?vue&type=style&index=0&id=b06b3132&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b06b3132"]])

export default __exports__